<div class="auth-callback">
  <p>Autenticando...</p>
</div>
